import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box } from "../Box/Box.mjs";
import { ScrollContainer } from "../private/ScrollContainer/ScrollContainer.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { TableContext } from "./TableContext.mjs";
import { table } from "./Table.css.mjs";
const Table = forwardRef(
  ({ alignY = "center", children, label, data, ...restProps }, ref) => /* @__PURE__ */ jsx(TableContext.Provider, { value: { alignY }, children: /* @__PURE__ */ jsx(ScrollContainer, { children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "table",
      width: "full",
      background: "surface",
      borderRadius: "large",
      overflow: "hidden",
      "aria-label": label,
      className: table,
      ref,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  ) }) })
);
export {
  Table
};
